import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Row, Col, Table, Button, Tooltip, OverlayTrigger, Glyphicon } from 'react-bootstrap'
import PurchasePresentTypeModalPage from '../../../containers/masters/PurchasePresentTypeModalPage'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputText from '../../commons/form/InputText'

class PurchasePresentTypeMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        searchName: null,
        searchDescription: null
      }
    }
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchPurchasePresentTypeList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchPurchasePresentTypeList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleNameChange (searchName) {
    if (this.state.filter.searchName !== searchName) {
      this.setState({ filter: { ...this.state.filter, searchName } })
    }
  }

  handleDescriptionChange (searchDescription) {
    if (this.state.filter.searchDescription !== searchDescription) {
      this.setState({ filter: { ...this.state.filter, searchDescription } })
    }
  }

  searchPurchasePresentTypeList () {
    this.props.actions.fetchPurchasePresentTypeList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  resetFilters () {
    this.setState({
      filter: {
        searchName: null,
        searchDescription: null
      }
    }, () => { this.searchPurchasePresentTypeList() })
  }

  render () {
    const {
      t, purchasePresentTypeMastersList, pagesCount, purchasePresentCount, filter,
      filter: { page },
      actions: { deletePurchasePresentTypeModal, openPurchasePresentTypeModal, recoverPurchasePresentTypeModal, fetchPurchasePresentTypeList }
    } = this.props

    const tKey = 'MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t('MASTERS.EDIT')}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t('MASTERS.DELETE')}</Tooltip>)
    const recoverTooltip = (<Tooltip id="recoverTooltip">{t('MASTERS.RECOVER')}</Tooltip>)
    const hasFilters = (this.state.filter.searchDescription || this.state.filter.searchName)

    return (
      <div className="admin-wrapper">
        <PurchasePresentTypeModalPage/>
        <Row className="section-users-header">
          <Col sm={12}>
            <div className="header-panel">
              <h4>{t(`${tKey}PURCHASE_PRESENT_TYPE_MASTERS.PURCHASE_PRESENT_TYPE_TITLE`)}</h4>
            </div>
          </Col>
        </Row>
        <Row>
          <div className="search-form">
            <span className="title-search"><i className="ico-search" /> {t(`${tKey}PURCHASE_PRESENT_TYPE_MASTERS.SEARCH_PURCHASE_PRESENT_TYPE_MASTERS_TITLE`)}</span>
            <Row>
              <Field
                name="filters.name"
                colSm={2}
                controlLabel={t(`${tKey}NAME`)}
                placeholder={t(`${tKey}NAME`)}
                component={InputText}
                onInputChange={(value) => this.handleNameChange(value)}
              />
              <Field
                name="filters.description"
                colSm={2}
                controlLabel={t(`${tKey}DESCRIPTION`)}
                placeholder={t(`${tKey}DESCRIPTION`)}
                component={InputText}
                onInputChange={(value) => this.handleDescriptionChange(value)}
              />
              <Col sm={8} className="btn-wrapper">
                <Button
                  className={'btn-white btn-icon btn-input btn-white search-button'}
                  style={{ width: '100%' }}
                  onClick={() => this.searchPurchasePresentTypeList()}>
                  <i className="ico-search" />
                  {t(`${tKey}SEARCH_BTN`)}
                </Button>
                <Button
                  className={'btn-icon btn-input ' + (hasFilters ? 'btn-standard' : 'btn-cancel')}
                  onClick={() => {
                    this.props.initialize({})
                    this.resetFilters()
                  }}
                >
                  <i className="ico-cancel" />
                  {t(`${tKey}RESET_BUTTON`)}
                </Button>
              </Col>
            </Row>
          </div>
        </Row>
        <Col sm={12} className="col-row  section-users-body">
          <Table className="editable-table" hover responsive>
            <thead>
              <tr>
                <th onClick={() => { this.changeOrder('uo') }}>
                  {t('MASTERS.PURCHASE_PRESENT_TYPE_MASTERS.ORGANIZED_UNIT')}
                  <i className={this.getSortIcon('name')} />
                </th>
                <th onClick={() => { this.changeOrder('name') }}>
                  {t(`${tKey}NAME`)}
                  <i className={this.getSortIcon('name')} />
                </th>
                <th onClick={() => { this.changeOrder('description') }}>
                  {t(`${tKey}DESCRIPTION`)}
                  <i className={this.getSortIcon('description')} />
                </th>
                <th style={{ width: '77px' }}>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
              </tr>
            </thead>
            <tbody>
              {purchasePresentTypeMastersList && purchasePresentTypeMastersList.map((purchasePresentTypeMaster, idx) => (
                <tr key={idx} className={purchasePresentTypeMaster.isDeleted ? 'is-deleted' : ''}>
                  <td>{purchasePresentTypeMaster.organizedUnitName}</td>
                  <td>{purchasePresentTypeMaster.name}</td>
                  <td>{purchasePresentTypeMaster.description}</td>
                  <td>
                    {!purchasePresentTypeMaster.isDeleted ? (
                      <div>
                        <a onClick={() => openPurchasePresentTypeModal(this.state.uoId, purchasePresentTypeMaster.purchasePresentTypeId)}>
                          <OverlayTrigger placement="left" overlay={editTooltip}>
                            <i className="ico-edit-white" />
                          </OverlayTrigger>
                        </a>
                        <a onClick={() => deletePurchasePresentTypeModal(this.state.uoId, purchasePresentTypeMaster.purchasePresentTypeId)}>
                          <OverlayTrigger placement="left" overlay={deleteTooltip}>
                            <i className="ico-trash" />
                          </OverlayTrigger>
                        </a>
                      </div>
                    ) : (
                      <a onClick={() => recoverPurchasePresentTypeModal(this.state.uoId, purchasePresentTypeMaster.purchasePresentTypeId)}>
                        <OverlayTrigger placement="left" overlay={recoverTooltip}>
                          <Glyphicon glyph="repeat" />
                        </OverlayTrigger>
                      </a>
                    )}
                  </td>
                </tr>
              ))}
              {(purchasePresentTypeMastersList === null || purchasePresentTypeMastersList === undefined || purchasePresentTypeMastersList.length === 0) &&
            <tr>
              <td colSpan={4}><h2>{t(`${tKey}PURCHASE_PRESENT_TYPE_MASTERS.RESULTS_NOT_FOUND`)}</h2></td>
            </tr>}
              <tr className="button-table-wrapper">
                <td>
                  <Button
                    className="btn-editable-table btn-standard"
                    onClick={() => openPurchasePresentTypeModal()}>
                  + {t('MASTERS.ADD')}
                  </Button>
                </td>
              </tr>
            </tbody>
          </Table>
          <div className="section-users-footer">
            <nav key={1} className="text-center">
              <IDocCarPagination
                id="btn_pag_finance"
                page={page}
                pagesCount={pagesCount}
                totalRows={purchasePresentCount}
                onSelectAction={(value) => fetchPurchasePresentTypeList({ ...filter, ...this.state.filter, page: value })}
              />
            </nav>
          </div>
        </Col>
      </div>
    )
  }
}

export default reduxForm({
  form: 'listPurchasePresentType'
})(PurchasePresentTypeMaster)
